/* eslint-disable @typescript-eslint/no-explicit-any */

import { useEffect, useState } from 'react';
import { DataAPIClientError } from './DataAPIClient';
import { useDataAPIClient } from './DataAPIClientProvider';
import { OrgSettingEntity } from './types';

interface State {
  readonly data?: OrgSettingEntity[];
  readonly error?: DataAPIClientError;
  readonly isLoading: boolean;
}

interface Result extends State {
  readonly refetch: () => Promise<void>;
}

export default function useDataAPIGetOrgSettingsByOrgID(orgID: string): Result {
  const client = useDataAPIClient();
  const [state, setState] = useState<State>({ isLoading: false });

  async function fetch(): Promise<void> {
    setState({ isLoading: true });

    try {
      const data = await client.getOrgSettingsByOrgID(orgID);

      setState({ isLoading: false, data });
    } catch (error: any) {
      setState({ isLoading: false, error });
    }
  }

  useEffect(() => {
    if (!orgID) return;

    fetch();
  }, [orgID]);

  return { ...state, refetch: fetch };
}
